/**
*****************************************
*                                       *
* NAGARRO  - CSX - CONFIDENTIAL         *
*                                       *
*****************************************
*/

import { AppUtilityService } from './app-utility.service';
import { BehaviorSubject ,  Observable ,  Subject } from 'rxjs';
import { ConfigService } from './config.service';
import { Injectable } from '@angular/core';
import { LmsLoggerService } from '../../core/services/lms-logger.service';
import { LmsModuleService } from './lms-module.service';
import { LocoDetail } from '../model/loco-detail.model';
import { Tab } from '../../core/model/tab.model';
import { TabService } from './tab.service';
import { TerminalHandlingUpdateRequest } from '../../core/model/terminal-handling-update-request-model';
import { AllocDeallocData } from '../../yard-local/shared/model/alloc-dealloc-data.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { tap } from 'rxjs/operators';

/**
 * @export
 * @class PopupService
 */
@Injectable()
export class PopupService {

  success: any;
  successObservable: Observable<any>;
  successSubject: Subject<any>;

  locoIcon: any;
  locoIconObservable: Observable<any>;
  locoIconSubject: Subject<any>;

  locoData: Observable<LocoDetail>;
  locoDataBS: BehaviorSubject<LocoDetail>;

  pageMode: string;
  submitBtnId: string;

  popupOpr: any;
  popupOprObservable: Observable<any>;
  private popupOprSubject: Subject<any>;

  private _header;
  private _content;

  RESOURCE_URL: string;
  configData: any;

  popup: Observable<Object>;


  /**
   * Creates an instance of PopupService.
   * @param {HttpClient} http
   * @param {LmsLoggerService} lmsLoggerService
   * @param {ConfigService} configService
   *
   * @memberOf PopupService
   */
  constructor(private http: HttpClient,
    private lmsLoggerService: LmsLoggerService,
    private configService: ConfigService,
    private lmsModuleService: LmsModuleService,
    private appUtilityService: AppUtilityService,
    private tabService: TabService) {
    this.configData = this.configService.getConfigData();
    const popup = { 'display': false };
    this._content = '<b>rituraj</b>';
    this.popupOprSubject = <Subject<any>>new Subject<any>();
    this.popupOprObservable = this.popupOprSubject.asObservable();
    this.successSubject = <Subject<any>>new Subject<any>();
    this.successObservable = this.successSubject.asObservable();
    this.locoIconSubject = <Subject<any>>new Subject<any>();
    this.locoIconObservable = this.locoIconSubject.asObservable();
    this.locoDataBS = <BehaviorSubject<LocoDetail>>new BehaviorSubject<LocoDetail>({});
    this.locoData = this.locoDataBS.asObservable();
    this.pageMode = 'Read';
    this.submitBtnId = 'defaultSearchButton';
  }

  /**
   * @memberOf PopupService
   */
  set header(newHeader) {
    this._header = newHeader;
  }

  /**
   * @readonly
   *
   * @memberOf PopupService
   */
  get header() {
    return this._header;
  }

  /**
   * @returns
   *
   * @memberOf PopupService
   */
  getContent() {
    return this._content;
  }

  /**
   * @param {string} mode
   *
   * @memberOf PopupService
   */
  public setPageMode(mode: string) {
    if (mode && mode.trim().length > 0) {
      if (mode.toUpperCase() === 'DIALOG') {
        const bodyElem = document.getElementById('lmsApplication');
        if (bodyElem) {
          bodyElem.setAttribute('class', 'dialogBodyScrollFreeze');
        }
      }
      this.pageMode = mode;
    } else {
      this.pageMode = 'Read';
      const bodyElem = document.getElementById('lmsApplication');
      if (bodyElem) {
        bodyElem.removeAttribute('class');
      }
    }
  }

  /**
   * @returns {string}
   *
   * @memberOf PopupService
   */
  public getPageMode(): string {
    return this.pageMode;
  }

  /**
   * @param {string} id
   *
   * @memberOf PopupService
   */
  public setSubmitBtnId(id: string) {
    if (id && id.length > 0) {
      this.submitBtnId = id;
    } else {
      this.submitBtnId = 'defaultSearchButton';
    }
  }

  /**
   * @returns {string}
   *
   * @memberOf PopupService
   */
  public getSubmitBtnId(): string {
    return this.submitBtnId;
  }

  /**
   * @param {*} success
   *
   * @memberOf PopupService
   */
  public updateSuccess(success: any) {
    this.success = success;
    this.successSubject.next(this.success);
  }

  /**
   * @param {*} operation
   *
   * @memberOf PopupService
   */
  public setPopupOperation(operation: any) {
    this.popupOpr = operation;
    this.popupOprSubject.next(this.popupOpr);
  }

  /**
   * @param {string} terminal
   * @param {TerminalHandlingUpdateRequest} terminalHandlingUpdateRequest
   * @param {string} wc
   * @returns {Observable<Response>}
   *
   * @memberOf PopupService
   */
  updateThp(terminalHandlingUpdateRequest: TerminalHandlingUpdateRequest, wc: string): Observable<Response> {
    const apiUrl = this.configData.urls.API_URL;
    const RESOURCE_URL = '/terminals/';
    let headers = new HttpHeaders();
    const opr = 'UTHP';
    headers = headers.append('Content-Type', 'application/json');
    const options = { headers: headers };
    return this.http.put<any>(`${apiUrl}${RESOURCE_URL}${terminalHandlingUpdateRequest.thpTerminal}/locomotives/thp?opr=${opr}&wc=${wc}`,
      JSON.stringify(terminalHandlingUpdateRequest), options).pipe(
        tap(() => this.lmsLoggerService.logInfo('terminalHandlingService => updateThp()',
        `Terminal Hanlding Plan Updated for ${JSON.stringify(terminalHandlingUpdateRequest)}`))
      );
  }

  /**
   * @param {*} request
   * @param {string} terminalId
   * @param {string} win
   * @returns
   *
   * @memberOf PopupService
   */
  cancelLocomotivePlan(request: any, terminalId: string, win: string) {
    const apiUrl = this.configData.urls.API_URL;
    const RESOURCE_URL = '/terminals/';
    let headers = new HttpHeaders();
    const opr = 'CPLN';

    headers = headers.append('Content-Type', 'application/json');
    const options = { headers: headers };
    if (win && win.trim().toUpperCase() === 'LWLS') {
      terminalId = 'locostatus'; // for loco status screen no terminal id specified.
    }
    return this.http.put(`${apiUrl}${RESOURCE_URL}${terminalId}/thp?opr=${opr}&win=${win}`,
      JSON.stringify(request), options);
  }

  getLocomotiveInformation(locoId: string) {
    const apiUrl = this.configData.urls.API_URL;
    const RESOURCE_URL = '/locomotives/status';
    const opr = 'INQU';

    return this.http.get(`${apiUrl}${RESOURCE_URL}?id=${this.appUtilityService.formatLocomotiveId(locoId)}&opr=${opr}`);
  }

  getLocomotiveIconInformation(tab: Tab, locoId: string): any {
    if (tab) {
      this.getLocomotiveInformation(locoId).subscribe((data: any) => {
        if (data && data.priorityCode) {
          const pCode = parseInt(data.priorityCode, 10);
          if (pCode >= 1 && pCode <= 4) {
            const responseLocoStatusArr: Array<LocoDetail> = data.locoStatusList;
            const locoIcon: LocoDetail = this.getLocoDetailObj(responseLocoStatusArr, locoId);
            if (locoIcon) {
              tab.tabSearchParameter.icon = locoIcon;
              this.lmsModuleService.updateSelectedTab(tab);
              this.locoIconSubject.next({ data: locoIcon, opr: 'success' });
            } else {
              this.locoIconSubject.next({ data: null, opr: 'error' });
            }
          } else {
            this.locoIconSubject.next({ data: null, opr: 'error' });
          }
        }
      },
        error => {
          this.locoIconSubject.next({ data: null, opr: 'error' });
        });
    }
  }

  public getLocoDetailObj(responseLocoStatusArr: Array<LocoDetail>, locoId: string): LocoDetail {
    let loco: LocoDetail;
    if (locoId) {
      for (let i = 0; i < responseLocoStatusArr.length; i++) {
        if (responseLocoStatusArr[i] && (responseLocoStatusArr[i].validationFlag !== 'C' && responseLocoStatusArr[i].validationFlag !== 'H') &&
          responseLocoStatusArr[i].locomotiveIdentifier &&
          this.appUtilityService.formatLocomotiveId(responseLocoStatusArr[i].locomotiveIdentifier.toUpperCase()) ===
          this.appUtilityService.formatLocomotiveId(locoId.toUpperCase())) {
          loco = responseLocoStatusArr[i];
        }
      }
    }
    return loco ? loco : null;
  }

  deAllocateLocomotives(allocDeallocData: AllocDeallocData, windowCode: string): Observable<Response> {
    let headers = new HttpHeaders();
    const apiUrl = this.configData.urls.API_URL;
    const functionCode = 'DEAL';
    headers = headers.append('Content-Type', 'application/json');
    const options = { headers: headers };
    this.lmsLoggerService.logInfo('YardLocalService=>deAllocateLocomotives service call starts');
    return this.http.post<any>(`${apiUrl}/locomotives/deal?opr=${functionCode}&wc=${windowCode}`,
        allocDeallocData, options).pipe(
          tap(() => this.lmsLoggerService.logInfo('YardLocalService=>deAllocateLocomotives service call ends'))
        );
  }

  allocateLocomotives(allocDeallocData: AllocDeallocData, windowCode: string): Observable<Response> {
      let headers = new HttpHeaders();
      const apiUrl = this.configData.urls.API_URL;
      const functionCode = 'ALOC';
      headers = headers.append('Content-Type', 'application/json');
      const options = { headers: headers };
      this.lmsLoggerService.logInfo('YardLocalService=>allocateLocomotives service call starts');
      return this.http.post<any>(`${apiUrl}/locomotives/aloc?opr=${functionCode}&wc=${windowCode}`,
          allocDeallocData, options).pipe(
            tap(() => this.lmsLoggerService.logInfo('YardLocalService=>allocateLocomotives service call ends'))
          );
  }

}
